import { useState, useContext } from 'react';
import { MdOutlineLogout } from 'react-icons/md';
import styles from '../styles/sidebar.module.scss';
import common from '../common.module.scss';
import { logout } from '../api/authApi';
import { Link, useNavigate } from 'react-router-dom';
import { EmployeeContext } from '../context/EmployeeContext.jsx';

const Sidebar = ({ selectedPage, setSelectedPage, isOpen, onClose }) => {
    const [isExpandedSys, setIsExpandedSys] = useState(false);
    const [isExpandedSchedule, setIsExpandedSchedule] = useState(false);

    const navigate = useNavigate();
    const { employee } = useContext(EmployeeContext);
    const name = employee?.name || 'admin';

    const handleToggleSys = () => setIsExpandedSys((prev) => !prev);
    const handleToggleSchedule = () => setIsExpandedSchedule((prev) => !prev);

    const renderNavItem = (label, key) => {
        const isActive = selectedPage === key;
        return (
            <li
                key={key}
                className={`${styles.sideBarLink} ${isActive ? styles.active : ''}`}
                onClick={() => setSelectedPage(key)}
            >
                <p className="body text-white">{label}</p>
            </li>
        );
    };

    const handleLogout = async () => {
        try {
            const refresh = localStorage.getItem("adminRefreshToken");
            await logout(refresh);
            localStorage.removeItem('adminRefreshToken');
            localStorage.removeItem('adminAccessToken');
        } catch (err) {
            console.error("Ошибка выхода", err);
        } finally {
            navigate('/admin/auth');
        }
    };

    return (
        <>
            {/* Затемнение на мобильной версии */}
            <div
                className={`${styles.backdrop} ${isOpen ? styles.show : ''}`}
                onClick={onClose}
            />
            <aside className={`${styles.sideBar} ${isOpen ? styles.open : ''}`}>
                <span className={styles.sideBarHeader}>
                    <h4>{name}</h4>
                    <div className={common.serviceButton}>
                        <MdOutlineLogout className={styles.logout} onClick={handleLogout} />
                    </div>
                </span>

                {/* Аккордеон */}
                <div className="accordion" id="accordionOne">
                    <li className={styles.sideBarLink}>
                        <p
                            className={`accordion-button ${styles.accordionButton} ${isExpandedSys ? '' : 'collapsed'}`}
                            onClick={handleToggleSys}
                        >
                            Элементы системы
                        </p>
                    </li>
                    <div className={`accordion-collapse collapse ${isExpandedSys ? 'show' : ''}`}>
                        <div className="accordion-body p-0">
                            <ul className={styles.list}>
                                {renderNavItem('Сотрудники', 'employees')}
                                {renderNavItem('Системы', 'systems')}
                                {renderNavItem('Залы', 'room')}
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Статичные пункты */}
                <ul className="p-0 mb-0">
                    {renderNavItem('Клиенты', 'clients')}
                    {renderNavItem('Карточки игр', 'games')}
                    {renderNavItem('Заявки на закрытую игру', 'privateGames')}
                    {renderNavItem('Промокоды', 'promo')}
                    {renderNavItem('Сертификаты', 'sertificate')}
                </ul>

                {/* Аккордеон */}
                <div className="accordion" id="accordionOne">
                    <li className={styles.sideBarLink}>
                        <p
                            className={`accordion-button ${styles.accordionButton} ${isExpandedSchedule ? '' : 'collapsed'}`}
                            onClick={handleToggleSchedule}
                        >
                            Расписание
                        </p>
                    </li>
                    <div className={`accordion-collapse collapse ${isExpandedSchedule ? 'show' : ''}`}>
                        <div className="accordion-body p-0">
                            <ul className={styles.list}>
                                {renderNavItem('Список', 'schedule')}
                                {renderNavItem('Календарь', 'calendar')}
                                {renderNavItem('Слоты', 'slots')}
                            </ul>
                        </div>
                    </div>
                </div>
                <Link to="/" className="mt-auto px-3">
                    <img className="img-fluid" src="/images/logo-white.svg" alt="Подземелье" />
                </Link>
            </aside>
        </>
    );
};

export default Sidebar;
